import React, {useState} from 'react';
import {allRewardKinds} from "../../data/Enums";
import cl from "../CountriesPage/CountriesPage.module.css";
import {Divider} from "@mui/material";
import RewardsSubPage from "./RewardsSubPage";
import RewardsPageMenuItem from "./RewardsPageMenuItem";
import {capitalize} from "../../utils/TextUtil";

const RewardsPage = ({isAddSubMode}) => {

    const [currentKind, setCurrentKind] = useState(allRewardKinds[0]);

    return (
        <div className={cl.main}>
            <div className={cl.menu}>
                {allRewardKinds.map(item => (
                    <RewardsPageMenuItem
                        key={item.id}
                        title={capitalize(item.pluralTitle)}
                        selected={item === currentKind}
                        onClick={() => setCurrentKind(item)}
                    />
                ))}
            </div>
            <Divider sx={{margin: "0 10px"}}/>
            <div className={cl.workArea}>
                <RewardsSubPage key={currentKind.id} isAddSubMode={isAddSubMode} kind={currentKind.id}/>
            </div>
        </div>
    );
};

export default RewardsPage;